module.exports = __webpack_public_path__ + "media/unipod/icon-cabin-assembly-black-afeda306.svg";